import gql from 'graphql-tag';

export const getAllReminderRulesQuery = gql`
  query getAllReminderRules($channelId: UUID!) {
    getAllReminderRules(channelId: $channelId) {
      id
      createdAt
      updatedAt
      createdBy
      updatedBy
      groupId
      teamId
      action
      target
      order
      name
      triggerTiming
      triggerTime
      triggerStatuses
    }
  }
`;
